(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_option-drawers"] && !Shopify.designMode) return;
  try {
    (function () {
    function moveOptionDrawerBtns() {
      var injectedOptions = new Set();

      document.querySelectorAll('[data-option-drawer-btn]').forEach(function (tpl) {
        var optName = tpl.dataset.forOption;
        if (!optName || injectedOptions.has(optName)) return;

        var frag = document.importNode(tpl.content, true);
        var btn = frag.firstElementChild;
        if (!btn) return;

        injectedOptions.add(optName);

        document.querySelectorAll('[data-option-group]').forEach(function (group) {
          if (group.dataset.optionName !== optName) return;

          var header = group.querySelector('header');
          if (!header || header.querySelector('[data-option-drawer-injected]')) return;

          var clone = btn.cloneNode(true);
          clone.setAttribute('data-option-drawer-injected', 'true');
          header.appendChild(clone);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moveOptionDrawerBtns);
    } else {
      moveOptionDrawerBtns();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
